import { forwardRef, type Ref, type SVGProps } from "react";
const IconUndoFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M22.536 14.536a5 5 0 1 0-7.072-7.072l-.005.006-4.6 4.53h4.14a2 2 0 0 1 0 4H6a2 2 0 0 1-2-2V5a2 2 0 1 1 4 0v4.2l4.643-4.57a9 9 0 0 1 12.724 12.73l-.002.003-11.98 12.046a2 2 0 0 1-2.835-2.82l11.983-12.05z" />
  </svg>
);
const ForwardRef = forwardRef(IconUndoFilledSVG);
ForwardRef.displayName = "IconUndoFilled";
export { ForwardRef as IconUndoFilled };
